import type { UIStringsOverride } from "../i18n-ui.ts";

/** Korean (ko) UI strings. */
export const ko: UIStringsOverride = {
  actions: {
    addToCursor: "Cursor에 추가",
    addToVscode: "VS Code에 추가",
    askAI: "이 페이지에 대해 AI에게 질문",
    connectMcp: "MCP에 연결",
    copied: "복사됨!",
    copyClaudeCode: "Claude Code 명령 복사",
    copyCode: "코드 복사",
    copyCodex: "Codex 명령 복사",
    copyMarkdown: "Markdown으로 복사",
    copyServerUrl: "서버 URL 복사",
    edit: "GitHub에서 편집",
    export: "내보내기",
    exportEpub: "EPUB으로 내보내기",
    exportPdf: "PDF로 내보내기",
    generating: "생성 중…",
    openIn: "{name}에서 열기",
    openInChat: "채팅에서 열기",
    scrollToTop: "맨 위로",
  },
  ask: {
    ai: "AI",
    clear: "대화 지우기",
    close: "닫기",
    copy: "대화 복사",
    empty: "문서에 대해 질문하세요.",
    error: "죄송합니다. 문제가 발생했습니다.",
    label: "질문하기",
    placeholder: "질문하기…",
    send: "보내기",
    tip: "팁: 다음 키로 채팅을 열고 닫을 수 있습니다",
    title: "AI에게 질문",
    you: "나",
  },
  banner: { dismiss: "공지 닫기" },
  changelog: {
    description: "제품 업데이트 및 릴리스 노트.",
    showReleases: "{version} 릴리스 보기",
    title: "변경 로그",
  },
  content: {
    diagramError: "이 다이어그램을 표시할 수 없습니다.",
  },
  feedback: {
    no: "아니요",
    question: "이 페이지가 도움이 되었나요?",
    thanks: "의견 주셔서 감사합니다!",
    yes: "예",
  },
  languageSwitcher: { label: "언어", untranslated: "번역되지 않음" },
  nav: {
    back: "뒤로",
    breadcrumb: "탐색 경로",
    closeNavigation: "탐색 닫기",
    deprecated: "지원 중단",
    featured: "추천",
    githubRepository: "GitHub 저장소",
    navigation: "탐색",
    primary: "기본",
    sections: "섹션",
    toggleNavigation: "탐색 전환",
    toggleTheme: "색상 테마 전환",
  },
  notFound: {
    description: "찾으시는 페이지를 찾을 수 없습니다.",
    home: "홈으로 돌아가기",
    title: "페이지를 찾을 수 없습니다",
  },
  page: {
    lastUpdated: "마지막 업데이트",
    next: "다음",
    pagination: "페이지네이션",
    previous: "이전",
    skipToContent: "본문으로 건너뛰기",
  },
  search: {
    all: "전체",
    allLanguages: "모든 언어",
    askAi: "AI에게 질문",
    askAiHint: "AI에게 즉시 답변 받기",
    button: "검색",
    devOnly: "검색은 프로덕션 빌드에서 사용할 수 있습니다.",
    error: "문제가 발생했습니다. 다시 시도해 주세요.",
    label: "문서 검색",
    navigate: "이동",
    noResults: "결과를 찾을 수 없습니다.",
    open: "열기",
    placeholder: "문서 검색…",
    popular: "인기",
    preview: "미리보기",
    results: "결과",
  },
  toc: { title: "이 페이지에서" },
};
